<template>
  <div id="share-page">
    <van-popup
      v-model="showDetailPopup"
      :style="{ height: '100%', width: '100%' }"
    >
      <audio id="video-player" :src="audioLink" style="visibility:hidden">
        您的浏览器不支持audio元素。
      </audio>
      <Speecher
        ref="speech"
        :speechPause="speechPause"
        @playAudio="playAudio"
        @pauseAudio="pauseAudio"
        @resetAudio="resetAudio">
      </Speecher>
      <template>
        <div class="fileElements">
          <div class="docContent" id="moreMerchant">
            <van-collapse v-model="activeNames">
              
              <van-collapse-item :title="shareScene == 'answer' ? '解答要素' : shareScene == 'paperword' ? '判例要素' : shareScene == 'taxnews' ? '案例要素' : '文件要素'" name="1">
                <div class="elements topLine">
                  <div class="title" v-if="shareScene == 'answer'">解答要素</div>
                  <div class="title" v-if="shareScene =='paperword'">判例要素</div>
                  <div class="title" v-if="shareScene == 'taxnews'">案例要素</div>
                  <div class="title" v-if="shareScene == 'policy'">文件要素</div>
                  <div class="content">内容</div>
                </div>
                <div
                  class="elements"
                  v-for="(item, index) in headers"
                  :key="index"
                >
                  <div class="title" v-html="item.t"></div>
                  <div class="content" v-html="item.v" @click="openLink"></div>
                </div>
              </van-collapse-item>
            </van-collapse>
            <div
              class="detail defaultFont"
              v-html="value"
              style="background: #fff; padding: 10px"
              @click="openLink"
            ></div>
          </div>
        </div>
        <van-tabbar :border="false">
          <div
            class="backStyle"
            style="
              background-color: #fff;
              diaplay: flex;
              justify-content: space-around;
              align-items: center;
            "
          >
            <div class="oprate-box" @click="backToLastFire">
              <van-image width="16" height="16" :src="lastFlag  ? returnImgUn: returnImg" />
              <span class="custom-title" :class="lastFlag? 'no-return': ''">返回</span>
            </div>
            <div class="oprate-box"  @click="backToHome">
              <van-image width="16" height="16" :src="homeImg" />
              <span class="custom-title">首页</span>
            </div>
            <div class="oprate-box" @click="showMailPop = true">
              <van-image width="16" height="13" :src="mailImg" />
              <span class="custom-title">邮箱</span>
            </div>
              <van-button
                :icon="shareImg"
                v-if="userId || wxgenerateid" 
                
                class="share-btn"
                @click="clickShare"
                >分享
            </van-button>
              <van-button
                :icon="shareImg"
                v-else
                class="share-btn"
                @click="clickShare"
                >转发
            </van-button>
          </div>
        </van-tabbar>
      </template>
      <!-- 浮动图标-首页注册 -->
    <div ref="container" v-if="accounttype !=3 && logStaNo" class="float-box">
      <van-button class="float-btn" type="primary" @click="goReg">去注册</van-button>
    </div>
    </van-popup>
    <van-popup
      v-model="showMailPop"
      position="bottom"
      closeable
      round
      style="width:100%; height:40%"
    >
      <div class="send-mail-wapper">
        <h3 style="text-align:center">发送文件到邮箱</h3>
        <div class="mail-box">
          <span>邮箱:</span>
          <van-field
            v-model="mailText"
            placeholder="请输入您的邮箱"
            :error-message="errMsg.mailText"
          />
        </div>
        <van-button
          :disabled="!mailText"
          style="width:100%;border-radius: 30px;height: 40px;"
          type="info"
          @click="sureSendMail"
          >确定</van-button
        >
      </div>
    </van-popup>
    <!-- dialog -->
    <van-overlay
      :show="showLoding"
      @click="showLoding = false"
      z-index="9999"
      :custom-style="{ backgroundColor: 'rgba(255, 255, 255, .8)' }"
    >
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" color="#1989fa"></van-loading>
      </div>
    </van-overlay>
    <!-- 浮动图标-分享 -->
    <div class="share-img-container">
      <van-popup
        v-model="shareImgShow"
        style="width:100%; height:100%"
        duration="0"
      >
        <div @click="closeShareImg" style="height:100%">
          <div class="share-img-box">
            <img src="../../assets/share/jiantou.png" alt="" />
          </div>
          <div class="share-content">
            点击右上角将文章分享给朋友
          </div>
        </div>
      </van-popup>
    </div>
    
   
    <!-- 初次进入页面未加载成功数据时显示loading -->
    <van-overlay
      :show="!value && !logStaNo"
      z-index="100"
      :custom-style="{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }"
      >
      <div class="wrapper" @click.stop>
        <van-loading type="spinner" vertical>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { host } from "../../../public/config.json";
import UploadFile from "@/components/common/uploadFile"; // 一键上传
import Speecher from "@/components/speecher"; // 一键上传
import baseConfig from "../../../public/config.json";
import { commonNotify, warningNotify } from "../../utils/lib/toast";
import { base } from "@/utils/lib/util.js";
import Login from "@/components/common/login";
import { searchToObj, getUrlParam, getShareParam} from "@/utils/lib/searchtoobj.js";
import TripleDES from "@/utils/lib/crypto.js";
import { sharePageUrl } from "../../../public/config.json";
import { commonDialog } from "@/utils/lib/toast.js";
import {
  getTempLogin,
} from "@/utils/lib/tempLogin.js"; // 临时登录
import { wxConfigShare } from "@/utils/newLibs/getWxOptions.js";

export default {
  data() {
    return {
      headers: [], // 文件要素
      value: "", // 文件正文内容
      activeNames: ["1"],
      strId: "",
      backDocFiresArr: [], // 返回的文件docid
      showLoding: false, // 是否显示加载
      uploadDocId: [],
      showLoginBtn: false,
      shareLabel: '',
      shareUserGuid: '',
      logStaNo: false, //微信登录状态
      IsUserLogin:false, // 是否账号登录状态
      loginWay:-1,
      shareImgShow: false,
      container: null,
      shareTitle: localStorage.getItem("shareTitle"),
      cutUrl: '',
      accounttype: 0,
      shareScene: localStorage.getItem('shareScene'),
      shareTypeVal: '',
      returnImg: require("../../assets/index/return_img.png"),
      returnImgUn: require("../../assets/index/return_un_img.png"),
      closeImg: require("../../assets/index/close_img.png"),
      shareImg: require("../../assets/index/share_img.png"),
      homeImg: require("../../assets/index/home.png"),
      mailImg: require("../../assets/index/mail.png"),
      speaech: '',
      showSpeecher: true,
      speechPause: false,
      speechValue: '',
      showDetailPopup:false,
      flow: 0,
      audioLink: '',
      showMailPop: false, //展示邮件弹窗
      mailText: '',
      mailPattern: /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/,
      errMsg: {
        mailText: ''
      },
      reqDocId: '',
      datapwd: '' //解析密码
    }
  },
 components: {
    Login,
    UploadFile,
    Speecher
  },
  beforeRouteLeave (to, from, next) {
    // 即将跳转的路由地址
    if (to.path !== 'sharepage') {
      window.sessionStorage.removeItem("docFiresArr")
      next()
    }
  },
  mounted() {
    const storageDocIds = sessionStorage.getItem('docFiresArr')
    if (storageDocIds) {
      this.backDocFiresArr = JSON.parse(storageDocIds)
    }
  },
  created() {
    const sharecode = getUrlParam(location.search, 'sharecode')
    localStorage.setItem("shareLabel", sharecode)
    // 分享链接框的标题分类记录
    this.shareScene = localStorage.getItem('shareScene')
    this.shareTypeVal = localStorage.getItem('shareTypeVal')
    
    if(!sessionStorage.getItem("userId") && !sessionStorage.getItem("wxgenerateid")) {
    this.templogin()
    } else {
      // 有账号登录时显示文件
      this.parseCode(localStorage.getItem("shareLabel"))
    } 
  },
  computed: {
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    activeName() {
      return this.$store.state.commonSearchData.activeName;
    },
    userGuid() {
      return this.$store.state.user.userGuid;
    },
    shareTypeNew() {
      if (this.shareType === 1) {
        return '👮最新政策发布'
      } else if (this.shareType === 2) {
        return '👮税收优惠政策'
      } else if (this.shareType === 3) {
        return '👮官方解答'
      } else if (this.shareType === 4) {
        return '👮涉税判例'
      } else if (this.shareType === 5) {
        return '👮税务案例'
      } else {
        return '👮税收政策法规'
      }
    },
    lastFlag() {
      return this.backDocFiresArr.length <= 1
    }
  },
  methods: {
    // 获取当前文件的语音链接
    getAudioLink(strId){
      this.$http.ReqGetTTs(strId).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            this.audioLink = res.item.signedurl
            this.flow = res.item.filesize
            this.speechPause = false
          } else if(res.rltcode === -160) {
            this.audioLink = ''
          }
        }
      });
    },
    playAudio(){
      if(this.audioLink) {
        this.$refs.speech.isPlaying = true
        this.speechPause = false
        this.$notify({
        color: "#fff",
        background: "#49d68c",
        message: `将使用${(this.flow/1024/1024).toFixed(2)}MB流量`,
        duration: 3000,
        });
        var audio = document.getElementById('video-player');
        audio.play()
        audio.addEventListener('ended', () => {
          this.speechPause = true
        })
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: '该文件语音正在生成中，请稍后再试',
          duration: 5000,
        })
        return false
      } 
    },
    pauseAudio() {
      if (this.speechPause) {
        document.getElementById('video-player').play()
        this.speechPause = false
      } else {
        document.getElementById('video-player').pause()
        this.speechPause = true
      }
    },
    resetAudio() {
      this.$refs.speech.isPlaying = false
      var audio = document.getElementById('video-player');
      audio.currentTime = 0
      audio.pause()
    },
    sureSendMail() {
      let strId = this.reqDocId;
      if(!this.mailPattern.test(this.mailText)) {
        this.errMsg.mailText = "邮箱输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.mailText = "";
        this.$http.reqSendMail({
          strdocid: strId,
          email: this.mailText
        }).then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.$notify({
                color: "#fff",
                background: "#49d68c",
                message: '邮件发送成功',
                duration: 3000,
              })
              this.showMailPop = false
            } else {
              this.$notify({
                color: "#fff",
                background: "#F27852",
                message: res.rltdesc,
                duration: 3000,
              })
            }
          }
        })
      }
    },
    // 获取标题
    getDocTitle(){
      let a 
       this.$nextTick(() => {
         a=document.getElementsByTagName('hh1')[0].innerText
         this.shareTitle=a
          this.getWxConfig()
        })
    },
    // 获取标题-去发文单位
    getTitle() {
      this.getWxConfig()
    },
    // 获取微信配置
    getWxConfig() {
      var reqBody = {
        url: location.href
      }
      this.$http
        .reqGetWxConfig(reqBody)
        .then((res) => {
          if(this.cutUrl) {
            wxConfigShare(res, this.shareTypeVal, this.shareTitle, this.cutUrl)
          }else{
            wxConfigShare(res,this.shareTypeVal, this.shareTitle, location.href)
          }
        })
        .catch(() => {})
    },
    backToHome() {
      this.resetAudio()
      if(this.logStaNo) {
        this.goReg()
      }else {
        this.$router.push("/newFiles")
      }
      window.localStorage.removeItem("shareTypeVal")
      window.localStorage.removeItem('shareTitle')
    },
    // 点击分享按钮
    clickShare() {
      // let req = {
      //   sharecode: localStorage.getItem("shareLabel")
      // };
      // this.$http
      //   .reqCalculateNum(req)
      //   .then((res) => {
      //     if (res.rtncode === 1) {
      //       if (res.rltcode === 1) {
      //         this.shareImgShow = true
      //       }}
      //   })
      this.shareImgShow = true
    },
    // 关闭分享指引
    closeShareImg() {
      this.shareImgShow = false
    },
    goReg() {
      this.$router.push({
        path: '/index',
        query: {
          shareUserGuid: this.shareUserGuid
        }
      })
    },
    // 微信授权
    wxAuto() {
      if(getUrlParam(location.search, 'code')) {
        this.wxLogin()
      } else {
        let req = {
        http_redirct: sharePageUrl+"?sharecode="+localStorage.getItem("shareLabel")
        };
        // return
        this.$http
          .reqPostGetWeixinPromise(req)
          .then((res) => {
            if (res.rtncode === 1 && res.rltcode === 1) {
              window.location.href = res.item.url
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
          });
      }
    },
    // 打开分享文档
    openDoc() {
      let req = {
        docid: this.strId,
        shareuserguid: this.shareUserGuid
      };
      this.$http
        .reqOpenDoc(req)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.getAudioLink(res.item.docid);

              this.showDetailPopup = true
              this.shareType = res.item.sharetype
              this.shareScene = res.item.scene
              res.item.strdocid = res.item.docid
              this.handleLoadDoc(res)
              this.uploadDocId[0] = res.item.docid
              if(localStorage.getItem("shareWay")) {
                this.shareImgShow = true
                window.localStorage.removeItem("shareWay")
              } else {
                this.shareImgShow = false
              }
              
              
              //打开他人分享文件-不点击分享按钮直接点击微信内置分享
              this.shareTitle = res.item.doctitle
              this.shareType = res.item.sharetype
              this.shareTypeVal = this.shareTypeNew
              // 非涉税判例去发文单位显示
              if(this.shareScene != 'paperword') {
                this.getTitle()
              } else {
                this.getDocTitle()
              }
              
            } else {
              warningNotify(res.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(res.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch((err) => {
          sessionStorage.clear();
          this.$cookie.delete("cookieObj");
          this.showLoding = false;
        });
         
    },
    // 解析分享码
    parseCode(shareLabel){
      let reqbody = {
        sharecode: shareLabel,
      };
      console.log(reqbody)
      this.$http
        .reqParseShareCode(reqbody)
        .then((res) => {
          this.strId = res.item.docid
          this.shareUserGuid = res.item.shareuserguid
          this.openDoc()
         
        })
        .catch((err) => {
          commonDialog(err.message, this);
        });
    },
    
    // 请登录查看全文 按钮
    login() {
      this.$refs.alertModel.changeShowLogin(true);
    },
    // 返回按钮
    backToLastFire() {
      this.resetAudio()
      if(this.lastFlag) {
        return
      }
      this.backDocFiresArr.pop()
      sessionStorage.setItem('docFiresArr',JSON.stringify(this.backDocFiresArr))
      setTimeout(() => {
        let lastId = this.backDocFiresArr[this.backDocFiresArr.length - 1]
        this.strId = lastId
        this.getDetail1(lastId)
      }, 10)
    },
    getDetail1(docid) {
      let bodyJson = {
        strdocid: docid,
        docid: "",
        h1hit: [],
        chit: [],
        chitseq: [],
        cutwords: [],
      };
      this.$http
        .reqPostDocDetail(bodyJson)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.shareScene = response.item.scene
              // this.getAudioLink(response.item.strdocid);
              // this.handleLoadDoc(response)
              this.getShareLink(response.item.strdocid)
              //newadd
              this.uploadDocId[0] = response.item.docid    
            } else {
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: response.rltdesc,
                duration: 3000,
              });
              this.showLoding = false;
            }
            if (this.accountstatus < 200) {
              // 该文件需要购买会员
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: "要获得普通下载权限,请前去在线商城购买账号等级",
                duration: 3000,
              });
              this.showLoding = false;
              return;
            }
            if (response.rltcode === -300) {
              // 该文件需要下载才能访问，请请求下载接口
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: "请登录电脑端下载该附件!   网址：www.holywiser.com",
                duration: 3000,
              });
              this.showLoding = false
            }
          } else {
            this.showLoding = false
          }
        })
        .catch(() => {
          this.showLoding = false
        });
    },
    // 文件显示
    handleLoadDoc(response) {
      if (response.rtncode === 1) {
        if (response.rltcode === 1) {
         this.reqDocId = response.item.strdocid
         
          let lastPushId = this.backDocFiresArr[this.backDocFiresArr.length - 1]
          if (lastPushId != this.reqDocId){
            this.backDocFiresArr.push(response.item.strdocid)
            sessionStorage.setItem('docFiresArr',JSON.stringify(this.backDocFiresArr))
          }
            
          this.showLoding = false
          this.headers = response.item.headers
          let tempdata = base.b64_to_utf8(response.item.body)
          this.value = tempdata.replace(/\r?\n/g, "<br />")
          this.speechValue = tempdata.replace(/<[^>]+>/g, '')
          if (response.item.hidden === true) {
            // true：临时登录  false：已登录
            this.showLoginBtn = true;
          }
        } else {
          this.$notify({
            color: "#fff",
            background: "#b99573",
            message: response.rltdesc,
            duration: 3000
          });
          this.showLoding = falsezh
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#b99573",
          message: response.rtndesc,
          duration: 3000
        });
        this.showLoding = false
      }
    },
    //获取分享链接
    getShareLink(strId) {
      this.showLoding = true
      let bodyJson = {
        strdocid: strId,
        docid: "",
        h1hit: [],
        chit: [],
        chitseq: [],
        cutwords: [],
      }
      this.$http
        .reqPostDocDetail(bodyJson)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.getAudioLink(response.item.strdocid)
              this.shareScene = response.item.scene
              localStorage.setItem('shareTypeVal', this.shareTypeNew)
              localStorage.setItem('shareTitle', response.item.doctitle)
              let body = {
                docid: strId
              };
              
              this.$http.reqGetShareUrl(body).then((res) => {
                //console.log('pai123', strId)
                window.location.href = res.item.url
              })
            } else {
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: response.rltdesc,
                duration: 3000,
              });
              this.showLoding = false
            }
            if (this.accountstatus < 200) {
              // 该文件需要购买会员
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: "要获得普通下载权限,请前去在线商城购买账号等级",
                duration: 3000,
              });
              this.showLoding = false
              return;
            }
            if (response.rltcode === -300) {
              // 该文件需要下载才能访问，请请求下载接口
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: "请登录电脑端下载该附件!   网址：www.holywiser.com",
                duration: 3000,
              });
              this.showLoding = false
            }
          } else {
            this.showLoding = false
          }
        })
        .catch(() => {
          this.showLoding = false
        })
    },
    // 点击链接
    openLink (value) {
      this.resetAudio()
      window.localStorage.removeItem("shareScene")
      if(this.logStaNo) {
        this.$notify({
          color: "#fff",
          background: "#b99573",
          message: "请您注册后在使用",
          duration: 3000
        });
        this.showLoding = false
        return
      } else {
        if (value.srcElement.id) {
          this.showLoding = true
          this.$nextTick(() => {
            let dom = document.getElementById("moreMerchant")
            dom.scrollIntoView()
          })
          this.strId = value.srcElement.id
          // no
          this.getDetail1(value.srcElement.id)
        }
      }
    },
    // 微信登录
    wxLogin () {
      let obj = searchToObj(location.href)
      let tempuserguid = localStorage.getItem("userguid");
      let newObj = {
        code: obj.code,
        state: obj.state,
        tempuserguid: tempuserguid
      };
      this.$http
        .reqPostWeixinLogin(newObj)
        .then((resp) => {
           
          if (resp.rtncode === 1) {
            if (resp.rltcode === 1) {
              this.bus.$emit("saveTokenHandle", resp, 1)
              this.parseCode(localStorage.getItem("shareLabel"))
            } else if (resp.rltcode === -3) {
              if(localStorage.getItem('accoutPwd')) {
                this.datapwd = TripleDES.decode("accoutPwd", localStorage.getItem('accoutPwd'))
                this.accocuntLogin()
              } else {
                console.log("13", resp);
                this.parseCode(localStorage.getItem("shareLabel"))
                this.logStaNo = true //未登录
                const index = location.href.indexOf('&code')
                var cutUrl
                if (index > 0) {
                  cutUrl = location.href.substr(0, index)
                }
                this.cutUrl = cutUrl
              }
            } else {
              console.log("wx登录+++", resp)
            }
          } else {
            commonDialog(resp.rtndesc, this);
          }
        })
        .catch((err) => {
          commonDialog(err.message, this);
        });
    },

    // 账号登录
    accocuntLogin() {
      // let str = localStorage.getItem("userguid")
      // str = str.slice(0, 3)
      let tmpGuid = localStorage.getItem("userguid")
      if(tmpGuid.indexOf("TMP") == -1) {
        tmpGuid = '';
      } else {
        tmpGuid = localStorage.getItem("userguid");
      }
      let bodyJson = {
        userid: localStorage.getItem('accoutName'),
        passwd: this.datapwd,
        tempid: tmpGuid,
      };
      this.$http
        .reqLogin(bodyJson)
        .then((resp) => {
          if (resp.rtncode === 1) {
            if (resp.rltcode === 1) {
              //console.log("账号登录啦===>", resp);
              this.logStaNo = false
              // 登录成功 刷新token
              this.bus.$emit("saveTokenHandle", resp, 0)
              this.parseCode(localStorage.getItem("shareLabel"))
            } else if(resp.rltcode === -1004) {
              this.$notify({
                color: "#fff",
                background: "#b99573",
                message: "密码或已修改，请至首页重新登录",
                duration: 5000
              });
            }
          }
      })
    },  
  // 临时登陆
    templogin () {
      this.$http.reqTempLogin().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            this.$store.commit("user/setUserId", resp.userid);
            this.$store.commit("user/setUserGuid", resp.userguid);
            this.$store.commit("user/setRealName", resp.realname);
            this.$store.commit("user/setToken", resp.token);
            this.$store.commit("user/setMobileNum", resp.mobilenum);
            this.$store.commit("user/setAccountType", resp.accounttype);
            this.$store.commit("user/setPermission", resp.permission);
            this.$store.commit("user/setAccountStatus", resp.accountstatus);
            this.$store.commit("user/setShowMsg", resp.showmsg)
            this.$store.commit("user/setMaxOpenNum", resp.maxopendocnum)
            this.$store.commit("user/setOpenNum", resp.opendocnum)
            this.$store.commit("user/setMaxToken", resp.maxtokens)
            this.$store.commit("user/setMallVer", resp.mallver)
            localStorage.setItem("userguid", resp.userguid);

            sessionStorage.setItem("token", resp.token);
            if (resp.permission != null && resp.permission.length > 0) {
              let items = [];
              resp.permission.forEach((item) => {
                items.push(item.f);
              });
              this.$store.commit("user/setPermissionArray", items);
            }

            this.accounttype = resp.accounttype
            if (this.accounttype == 3) {
              this.parseCode(localStorage.getItem("shareLabel"))
            } else {
              this.wxAuto()
            }
          }
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
@--line-color: #DCDEE2;
#share-page {
  position: relative;
  .float-box {
    position: absolute;
    top: 0px;
    right: 0px;
    .float-btn {
      right: 0;
    }
  }
  .float-connect-box {
    z-index: 999;
  }
  .share-img-container {
    .van-popup {
      background-color: rgba(0, 0, 0, 0.7);
      .share-img-box {
        display: flex;
        flex-direction: row-reverse;
        width: 100%;
        background-color: transparent;
        margin-bottom: 30px;
        img {
          width: 30%;
          height: 30%;
          margin-top: 20px;
          margin-right: 20px;
          background-color: transparent;
        }
      }
      .share-content {
        font-size: 20px;
        text-align: center;
        color: #fff;
      }
    }
  }
  .fileElements {
    height: 100%;
    background: #fff;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; // 重点
    }
    .topLine {
      border-top: 1px solid @--line-color;
    }
    .elements {
      display: flex;
      min-height: 40px;
      border-bottom: 1px solid @--line-color;
      color: #515a6e;
      font-size: 12px;
      border-right: 1px solid @--line-color;
      &:nth-child(odd) {
        background-color: #f8f8f9;
      }
      .title {
        flex: 0 0 27%;
        text-align: center;
        border-left: 1px solid @--line-color;
        border-right: 1px solid @--line-color;
        line-height: 40px;
      }
      .content {
        flex: 1;
        text-align: center;
        margin: auto 0;
      }
    }
    .docContent {
      margin-bottom: 60px;
    }
  }
  .backStyle {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
  }
  .oprate-box {
    padding:5px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .no-return {
      color: #999999;
    }
  }
  .share-btn {
    width: 3rem;
    border-radius: 30px;
    height: 40px;
    border-color: #00A7FA;
    background: linear-gradient(to right, #00A9FF, #0080FF);
    color: #ffffff;
  }
  .loginBtn {
    height: 280px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: -300px;
    background: rgba(255, 255, 255, 0.9);
  }
  /deep/.van-loading {
    display: flex;
    justify-content: center;
    margin-top: 10%;
  }
  .send-mail-wapper {
    padding: 0 20px;
    .mail-box {
      margin: 20px 0 30px 0;
      /deep/.van-cell {
        border-bottom:1px solid #F0F0F0;
        padding-left: 0px;
      }
      
    }
  }
  /deep/.van-popup__close-icon {
    color: #000;
  }
}
</style>

<style lang="less">
@import "~@/styles/article.less";
</style>
